module.exports = __webpack_public_path__ + "154b718becf2393aea46960f38f7f0d3.MP3";